import moment from "moment"
import parseHtml from 'html-react-parser'

const styles = {
  label: {
    color: "black",
    fontWeight: 400
  },
  text: {
    color: "#333",
  }
}

export default function ({ passType, subType, instanceData }) {
  try {
    if (passType === "boardingPass" && subType === "PKTransitTypeTrain") {

      let journey = instanceData.journey
      let legs = journey?.legs

      if (legs?.length) {

        const departDate = moment(legs[0].depart,"YYYYMMDDHHmmss")

        let itinerary = ""

        for (let l = 0; l < legs.length; l++) {
          const leg = legs[l]
          const changing = l < (legs.length - 1)

          let departDate = moment(leg.depart,"YYYYMMDDHHmmss")
          let arriveDate = moment(leg.arrive,"YYYYMMDDHHmmss")

          itinerary += `Depart at ${departDate.format("HH:mm")}\n`
          itinerary += `From ${leg.origin.name}\n`
          itinerary += getTrainDetails(leg)
          itinerary += `To ${leg.destination.name}\n`
          itinerary += `Arrive at ${arriveDate.format("HH:mm")}\n`
          if (leg.reservation) itinerary += getSeats(leg.reservation)
          if (changing) itinerary += getChangeInfo(leg, legs[l + 1])
        }

        return (
          <div style={{ padding: 15 }}>
            <div style={styles.label}>
              Itinerary {departDate.format("DD MMM YYYY")}
            </div>
            <div style={styles.text}>{parseHtml(itinerary.replace(/\n/g, "<br/>"))}</div>
          </div>
        )
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}

const getTrainDetails = leg => {
  if (leg.destination.name === leg.trainDestination) return `${leg.toc} train\n`
  else return `${leg.toc} train to ${leg.trainDestination}\n`
}

const getSeats = reservation => {
  return `\nYour assigned seat is Coach:${reservation.coach}, Seat:${reservation.seat}\n`
}

const getChangeInfo = (thisLeg, nextLeg) => {
  let changeInfo = '\n\n'

  const arriveTime = moment(thisLeg.arrive)
  const departTime = moment(nextLeg.depart)
  const changeTimeMins = departTime.diff(arriveTime, "minutes")

  const hours = Math.floor(changeTimeMins / 60)
  const mins = changeTimeMins - (hours * 60)

  let changeTime = hours ? `${hours} hour${hours > 1 ? "s" : ""}` : ""
  if (hours && mins) changeTime += " and "
  changeTime += mins ? `${mins} min${mins > 1 ? "s" : ""}` : ""

  if (thisLeg.destination.code !== nextLeg.origin.code) {
    changeInfo += `Transger to ${nextLeg.origin.name}\t\t${changeTime}\n`
  } else {
    changeInfo += `Transfer\t\t${changeTime}\n`
  }

  changeInfo += '\n\n'
  return changeInfo
}
